import React from 'react';
import styled from 'styled-components';
import { sizeVars } from '@routific/hive/v5';

interface PackageRowProps {
  children: React.ReactNode;
  'data-testid'?: string;
}

const RowContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${sizeVars.space[100]};
  position: relative;
  width: 100%;
`;

const PackageRow: React.FC<PackageRowProps> = ({ children, 'data-testid': testId }) => {
  return <RowContainer data-testid={testId}>{children}</RowContainer>;
};

export default PackageRow;
